import { PrivacyPolicy, TermsOfUse } from '@strata/react-page-templates';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

import { AuthCallback } from 'components/auth/AuthCallback';
import { LoggedOut } from 'components/auth/LoggedOut';
import { RequireAuth } from 'components/auth/RequireAuth';
import { Home } from 'components/home/Home';
import { UpdatesHistoryScreen } from 'components/home/UpdatesHistoryScreen';
import { ReferralFormPage } from 'components/referralForm/ReferralFormPage';
import { ReferralDetailPage } from 'components/referralHistory/ReferralDetailPage';
import { ReferralHistoryPage } from 'components/referralHistory/ReferralHistoryPage';
import { TermsAndConditions } from 'components/TermsAndConditions';
import { AppRoutes } from 'services/routes';

export const App = () => (
    <BrowserRouter basename="/">
        <Routes>
            <Route path={AppRoutes.callback} element={<AuthCallback />} />
            <Route path={AppRoutes.loggedOut} element={<LoggedOut />} />
            <Route element={<RequireAuth />}>
                <Route path={AppRoutes.home} element={<Home />} />
                <Route path={AppRoutes.referralForm} element={<ReferralFormPage />} />
                <Route path={AppRoutes.referralHistory} element={<ReferralHistoryPage />} />
                <Route path={AppRoutes.referralDetails()} element={<ReferralDetailPage />} />
                <Route path={AppRoutes.termsAndConditions} element={<TermsAndConditions />} />
                <Route path={AppRoutes.termsOfUse} element={<TermsOfUse />} />
                <Route path={AppRoutes.privacyPolicy} element={<PrivacyPolicy />} />
                <Route path={AppRoutes.updatesHistory} element={<UpdatesHistoryScreen />} />
            </Route>
            <Route path="*" element={<Navigate replace to={AppRoutes.home} />} />
        </Routes>
    </BrowserRouter>
);
